import React from 'react';

const OutcomeComponent = () => {
  return (
    <div className="sidebar-container help-sidebar">
      <p className="light-grey-text">HELP</p>
      <h1 className="title">What was the outcome of the project?</h1>
      <p className="alt-text">Try to answer these key questions:</p>
      <ul className="categoried-list">
        <li>
          What were the measurable improvements in the product based on your work?<br/>
          <span className="example-text">{'{'}ex: &quot;Improved Instagram Android&apos;s Feed scroll latency by 72%.&quot; {'}'}</span>
        </li>
        <li>
          How did you work further the goals of the company?<br/>
          <span className="example-text">{'{'}ex: &quot;As a result of this feature, the average content interactions per user increased by 26%, incetivizing users to stay longer on the Instagram platform and increasing ad revenue.&quot; {'}'}</span>
        </li>
      </ul>
      <h1 className="sub-title">Example</h1>
      <div className="panel">
        <p className="sub-title">What was the outcome of the project?</p>
        <p className="description">The company was able to launch the service on time and acquire 10,000 users.</p>
        <p className="description">Clients reported that the system helped them plan the spints better, and keep track of tasks and it&apos;s dependencies.</p>
        <p className="description">Faster release cycles with the CI/CD pipeline.</p>
        <p className="description">With this user base the company is now able to generate revenue, and is planning new features to grow in this market.</p>
      </div>
    </div>
  );
};

export default OutcomeComponent;
